export default "__VITE_ASSET__Czp27lSM__"